import { useLocation, useNavigate } from "react-router-dom";
import "./index.css";
import { useDispatch } from "react-redux";
import { ownerListViewAllAcc } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { toast } from "react-toastify";
import { toast_position } from "../../../../redux/features/Settings/Authorization";
import ListContainer from "../../../../components/_utils/CommonListView/ListContainer";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat";
import ListTextWithIcon from "../../../../components/_utils/CommonListView/ListSubComponent/ListTextWithIcon";
import TickerAnimation from "../../../../components/_utils/TickerAnimation";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";

const InternalAccListView = ({
  id,
  data,
  isSidebarOpen,
  isPopoverOpen,
  typepop,
  handleButtonClick,
  internalAccount,
  associateAccount,
  // setOpenInternalAssociate,
  showSearchBar,
  beneAccountId,
  txnPayLoad,
  setTxnPayLoad,
  setIsNeft,
  setIsRtgs,
  setIsImps,
  flow,
  accountType,
  setOpenBeneAssociate,
  scheduleIntenralTxn,
  isLabelClicked,
  setLabelAccounts,
  LabelAccounts,
  setlableInput,
  Labeldata,
  setLabeldata,
  filterRef,
  onCardNavigate,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--text-secondary)";
      case "rejected":
        return "var(--failed)";
      case "hold":
        return "var(--queued)";
      case "queued":
        return "var(--queued)";
      case "all":
        return "var(--text-primary)";
      case "settled":
        return "var(--settled)";
      default:
        return "var(--text-primary)";
    }
  };

  const listdata = data || [];

  const IntBneAccount = async (item) => {
    let data1 = await dispatch(
      ownerListViewAllAcc({
        bank_account_no: item?.bank_acc_no,
        pan: item?.pan_no,
        ifsc: item?.ifsc_code,
      }),
    );
    setTxnPayLoad({
      ...txnPayLoad,
      bankAccountIFSC: item?.ifsc_code,
      bankAccountName: item?.name,
      bankAccountNo: item?.bank_acc_no,
      beneAccountId: item?.id,
      isDestinationOwnerActive: item?.internal_account,
      destinationAccountBalance:
        data1?.payload?.owner_accounts[0]?.owner_account_balance,
      destinationAcountOwnerId: data1?.payload?.owner_accounts[0]?.id,
      destinationAcountOwnerLastUpdated:
        data1?.payload?.owner_accounts[0]
          ?.owner_account_balance_last_fetched_at_in_words,
    });

    setIsNeft(true);
    setIsRtgs(false);
    setIsImps(false);
  };

  return (
    <>
      <div
        className={`standard-list-view-alignment ${
          listdata.filter((item) => item.id !== beneAccountId).length ===
            GlobalConfiguration.lengthCheckZero && "flex-1"
        }`}
        style={{
          display:
            listdata.filter((item) => item.id !== beneAccountId).length ===
            GlobalConfiguration.lengthCheckZero
              ? "flex"
              : "grid",
        }}
      >
        {listdata?.filter((item) => item.id !== beneAccountId).length >
        GlobalConfiguration.lengthCheckZero ? (
          listdata
            ?.filter((item) => item.id !== beneAccountId)
            .map((item, index) => {
              return (
                <ListContainer
                  hoverHeight={
                    GlobalConfiguration.internalAccountListHoverHeight
                  }
                  filterRef={filterRef}
                  key={item.id}
                  isSelected={
                    Array.isArray(LabelAccounts) &&
                    LabelAccounts.includes(item.id)
                  }
                  isDisabled={
                    item.id == id ||
                    (isLabelClicked && item?.approval_status === "archived") ||
                    isSidebarOpen ||
                    isPopoverOpen ||
                    (typepop === "popup" &&
                      !associateAccount &&
                      (item?.approval_status === "blocked" ||
                        item?.approval_status === "archived" ||
                        item?.approval_status === "rejected")) ||
                    (typepop === "popup" &&
                      item?.approval_status !== "blocked" &&
                      item?.approval_status !== "archived" &&
                      item?.approval_status !== "rejected" &&
                      internalAccount === "internalAccount" &&
                      txnPayLoad?.ownerBankAccountNo === item?.bank_acc_no &&
                      txnPayLoad?.ownerBankIFSC === item?.ifsc_code &&
                      txnPayLoad?.ownerPan === item?.pan_no)
                  }
                  context={item}
                  onClickHandler={async () => {
                    if (
                      typepop === "popup" &&
                      (item?.approval_status === "blocked" ||
                        item?.approval_status === "archived" ||
                        item?.approval_status === "rejected") &&
                      !associateAccount
                    ) {
                      return;
                    } else if (typepop === "popup" && !associateAccount) {
                      if (isLabelClicked) {
                        if (LabelAccounts.includes(item.id)) {
                          setLabelAccounts(
                            LabelAccounts.filter((id) => id !== item.id),
                          );
                        } else {
                          setLabelAccounts([...LabelAccounts, item.id]);
                          setLabeldata([...Labeldata, item]);
                        }
                        setlableInput(false);
                      } else {
                        handleButtonClick(item);
                      }
                    } else {
                      if (!isLabelClicked) {
                        let selection = window.getSelection();
                        if (
                          selection.toString().length ===
                          GlobalConfiguration.lengthCheckZero
                        ) {
                          if (!isSidebarOpen) {
                            const redirectUrl =
                              internalAccount === "internalAccount" ||
                              accountType === "internal"
                                ? `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${item.id}`
                                : `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${item.id}`;
                            if (onCardNavigate) {
                              onCardNavigate(redirectUrl);
                              return;
                            }
                            if (associateAccount) {
                              // setOpenInternalAssociate(false);
                              setOpenBeneAssociate(false);
                            }
                            navigate(redirectUrl, {
                              state: {
                                isViewAll:
                                  internalAccount === "internalAccount" ||
                                  accountType === "internal"
                                    ? location.pathname ===
                                      "/internal_account_dashboard/internal_account_view_all"
                                      ? true
                                      : false
                                    : location.pathname ===
                                        "/beneficiary_account_dashboard/beneficiary_account_view_all"
                                      ? true
                                      : false,
                              },
                            });
                          }
                        }
                      } else {
                        if (LabelAccounts.includes(item.id)) {
                          setLabelAccounts(
                            LabelAccounts.filter((id) => id !== item.id),
                          );
                        } else {
                          setLabelAccounts([...LabelAccounts, item.id]);
                          setLabeldata([...Labeldata, item]);
                        }
                        setlableInput(false);
                      }
                    }
                  }}
                >
                  <list-body>
                    <div className="w-full flex justify-between pr-padding-sm gap-x-gap-sm py-padding-sm">
                      <div className={`flex flex-col gap-y-gap-sm w-full`}>
                        <div className="w-full flex gap-x-gap-sm">
                          <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-r-border-radius-md">
                            <CommonBankLogo
                              variant="small"
                              ifsc={item.ifsc_code}
                            />
                          </div>
                          <p className="text-text-primary text-font-xs flex-1 min-w-standard-account-min-width truncate flex font-normal">
                            <TickerAnimation
                              text={standardAccountNumberFormat(
                                item?.bank_acc_no,
                                true,
                              )}
                            />
                          </p>
                          <div className="border-l border-primary-bg"></div>
                          <div className="flex gap-x-gap-sm justify-end items-center">
                            <p
                              style={{
                                color: getStatusColor(item?.approval_status),
                              }}
                              className={` text-font-xs font-semibol capitalize min-w-standard-approval-status-min-width text-right`}
                            >
                              {item?.approval_status}
                            </p>

                            <img
                              style={{
                                display: isLabelClicked ? "flex" : "none",
                              }}
                              className="w-icon-sm h-icon-sm flex-shrink-0 cursor-pointer"
                              src={
                                Array.isArray(LabelAccounts) &&
                                LabelAccounts.includes(item.id)
                                  ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                  : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                              }
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="w-full pl-padding-sm  flex justify-between items-center relative">
                          <p
                            className={`text-font-xs text-text-primary flex-1 truncate font-normal`}
                          >
                            <TickerAnimation
                              text={accountNameStandardised(item?.name)}
                            />
                          </p>
                        </div>
                      </div>
                    </div>
                  </list-body>
                  <list-hover>
                    <ListTextWithIcon
                      type={"text"}
                      text={item?.labels?.join(", ") || "No labels assigned "}
                      iconComponentArray={[
                        {
                          icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                        },
                      ]}
                    />
                  </list-hover>
                </ListContainer>
              );
            })
        ) : (
          <div
            className="flex flex-col items-center justify-center m-auto w-full h-full"
            style={{
              height:
                typepop === "popup" && !showSearchBar
                  ? "h-full-height Qsmd:h-height-full"
                  : typepop === "popup" && showSearchBar
                    ? "var(--height-full)"
                    : "",
              overflowY: "scroll",

              scrollbarWidth: "none",
            }}
          >
            <img
              src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
              alt="No accounts found"
              className={` opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm`}
            />
            <p className="text-text-primary">No data found.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default InternalAccListView;
